/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentDetailsPaymentInternalInvestmentViewModel
 */
export interface PaymentDetailsPaymentInternalInvestmentViewModel {
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsPaymentInternalInvestmentViewModel
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsPaymentInternalInvestmentViewModel
     */
    payeeName?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsPaymentInternalInvestmentViewModel
     */
    investmentName?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsPaymentInternalInvestmentViewModel
     */
    planNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsPaymentInternalInvestmentViewModel
     */
    amount?: number;
}

/**
 * Check if a given object implements the PaymentDetailsPaymentInternalInvestmentViewModel interface.
 */
export function instanceOfPaymentDetailsPaymentInternalInvestmentViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaymentDetailsPaymentInternalInvestmentViewModelFromJSON(json: any): PaymentDetailsPaymentInternalInvestmentViewModel {
    return PaymentDetailsPaymentInternalInvestmentViewModelFromJSONTyped(json, false);
}

export function PaymentDetailsPaymentInternalInvestmentViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetailsPaymentInternalInvestmentViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'payeeName': !exists(json, 'PayeeName') ? undefined : json['PayeeName'],
        'investmentName': !exists(json, 'InvestmentName') ? undefined : json['InvestmentName'],
        'planNumber': !exists(json, 'PlanNumber') ? undefined : json['PlanNumber'],
        'amount': !exists(json, 'Amount') ? undefined : json['Amount'],
    };
}

export function PaymentDetailsPaymentInternalInvestmentViewModelToJSON(value?: PaymentDetailsPaymentInternalInvestmentViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'PayeeName': value.payeeName,
        'InvestmentName': value.investmentName,
        'PlanNumber': value.planNumber,
        'Amount': value.amount,
    };
}

